import IndividualGame, { TeamGame } from '../_types/IndividualGame';

const isTeamGame = (game: TeamGame | IndividualGame): game is TeamGame => {
  return (game as TeamGame).circles !== undefined;
};

export default isTeamGame;
